const { __ } = wp.i18n;
export default [
  {
    value: "auto",
    label: __("Auto", "uipress-lite"),
  },
  {
    value: "cover",
    label: __("Cover", "uipress-lite"),
  },
  {
    value: "contain",
    label: __("Contain", "uipress-lite"),
  },
];
